export enum ControlButtonSize {

    SIZE_20     = 20,
    SIZE_24     = 24,
    SIZE_28     = 28
}